import Injectable from '@/modules/shared/domain/dependency_injection/injectable';
import { ProfessionRepository } from '../../../domain/repository';
import fixtures from './fixtures.json';

@Injectable()
export default class ProfessionDummyRepository implements ProfessionRepository {
  findAll() {
    return Promise.resolve(fixtures);
  }
}
